import { render, staticRenderFns } from "./addGoods.vue?vue&type=template&id=a1a38614&scoped=true"
import script from "./addGoods.vue?vue&type=script&lang=js"
export * from "./addGoods.vue?vue&type=script&lang=js"
import style0 from "./addGoods.vue?vue&type=style&index=0&id=a1a38614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a38614",
  null
  
)

export default component.exports